import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';

const Type = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  validOptions,
  isDisabled,
  sx,
  error,
  labelSx,
  parentSx,
  fullWidth
}) => (
  <FormControl fullWidth={fullWidth} error={error !== ''} sx={{parentSx}}>
    <InputLabel id={`field-${id}-select-label`} sx={{labelSx}}>{label}</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id={id}
      name={name}
      value={defaultValue}
      label={label}
      onChange={onChange}
      sx={sx}
      disabled={isDisabled}
    >
      {validOptions?.map((k) => (
        <MenuItem key={`${id}-v-${k}`} value={k}>
          {k}
        </MenuItem>
      ))}
    </Select>
    {error !== '' && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

Type.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  validOptions: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  sx: PropTypes.shape(),
  labelSx: PropTypes.shape(),
  parentSx: PropTypes.shape(),
  error: PropTypes.string,
};
Type.defaultProps = {
  isDisabled: false,
  fullWidth: true,
  sx: {},
  labelSx: {},
  parentSx: {},
  error: '',
};

export default Type;
